import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { trackContentClick, trackCatalogExplore } from 'app/actions/AnalyticsGa4Actions';
import BibBriefInfo from './BibBriefInfo';

const mapDispatchToProps = dispatch => ({
  trackContentClick: bindActionCreators(trackContentClick, dispatch),
  trackCatalogExplore: bindActionCreators(trackCatalogExplore, dispatch)
});

export default connect(null, mapDispatchToProps)(BibBriefInfo);
